import {useCallback, useState} from 'react';

export function getAccessToken() {
    const tokenString = localStorage.getItem('access_token');
    const userToken = JSON.parse(tokenString);
    return userToken?.access_token || null;
}

export function getRefreshToken() {
    const refreshString = localStorage.getItem('refresh_token');
    const refreshToken = JSON.parse(refreshString);
    return refreshToken?.refresh_token || null;
}

export function useToken() {


    const [accessToken, setAccessToken] = useState(getAccessToken());
    const [refreshToken, setRefreshToken] = useState(getRefreshToken());

    const saveTokens = useCallback(({access_token, refresh_token}) => {
        localStorage.setItem('access_token', JSON.stringify({access_token}));
        localStorage.setItem('refresh_token', JSON.stringify({refresh_token}));
        setAccessToken(access_token);
        setRefreshToken(refresh_token);
    }, []);

    return {
        setTokens: saveTokens,
        accessToken,
        refreshToken,
    };
}


export function logOut() {
    localStorage.removeItem('access_token');
    window.location.href = '/';
}




